import React from "react";
import { Popover, Button } from "antd";
import { SortableHandle } from "react-sortable-hoc";

const DragHandle = SortableHandle(() => <div className="filters__drag" />);

class Filter extends React.Component {
  render() {
    const { params } = this.props;
    const popoverContent = this.props.params.types.map((x, i) => (
      <div className="filters__content" key={i}>
        {x.title} is &nbsp;
        <span className="filters__selection">at least {x.value}</span>&nbsp; in
        any case or &nbsp;
        <span className="filters__selection">at least {x.value}</span>&nbsp; in
        any control.
      </div>
    ));

    return (
      <div className="filters__item">
        <DragHandle />
        <div className="filters__row">
          <div className="filters__cell">
            <div className="filters__title">{params.title}</div>
          </div>
          <div className="filters__cell">{params.variants}</div>
          <div className="filters__cell">{params.genes}</div>
        </div>
        <div className="filters__flex">
          <div className="filters__types">
            {params.types.map((x, i) => (
              <Popover
                key={i}
                {...{
                  placement: "bottomLeft",
                  content: popoverContent,
                  ...(x.hide && { visible: false })
                }}
              >
                <div className="filters__type">
                  <div className="filters__preview">
                    <img className="filters__pic" src="/img/tick.svg" alt="" />
                  </div>
                  <div className="filters__caption">{x.title}</div>
                </div>
              </Popover>
            ))}
          </div>
          <div className="filters__actions">
            <Button className="filters__action">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="16"
                viewBox="0 0 14 16"
              >
                <path d="M4.33333333,3.99966667 L4.33333333,2.66633333 C4.33333333,1.92995367 4.930287,1.333 5.66666667,1.333 L8.33333333,1.333 C9.069713,1.333 9.66666667,1.92995367 9.66666667,2.66633333 L9.66666667,3.99966667 L11.6666667,3.99966667 L11.6666667,13.333 C11.6666667,14.0693797 11.069713,14.6663333 10.3333333,14.6663333 L3.66666667,14.6663333 C2.930287,14.6663333 2.33333333,14.0693797 2.33333333,13.333 L2.33333333,3.99966667 L4.33333333,3.99966667 Z" />
                <path d="M12.1666667,4.5 L12.1666667,13.333 C12.1666667,14.3455221 11.3458554,15.1663333 10.3333333,15.1663333 L3.66666667,15.1663333 C2.65414461,15.1663333 1.83333333,14.3455221 1.83333333,13.333 L1.83333333,4.5 L1,4.5 C0.723857625,4.5 0.5,4.27614237 0.5,4 C0.5,3.72385763 0.723857625,3.5 1,3.5 L3.83333333,3.5 L3.83333333,2.66633333 C3.83333333,1.65381129 4.65414463,0.833 5.66666667,0.833 L8.33333333,0.833 C9.34585537,0.833 10.1666667,1.65381129 10.1666667,2.66633333 L10.1666667,3.5 L13,3.5 C13.2761424,3.5 13.5,3.72385763 13.5,4 C13.5,4.27614237 13.2761424,4.5 13,4.5 L12.1666667,4.5 Z M2.83333333,4.5 L2.83333333,13.333 C2.83333333,13.7932373 3.20642935,14.1663333 3.66666667,14.1663333 L10.3333333,14.1663333 C10.7935707,14.1663333 11.1666667,13.7932373 11.1666667,13.333 L11.1666667,4.5 L2.83333333,4.5 Z M9.16666667,3.5 L9.16666667,2.66633333 C9.16666667,2.20609604 8.79357063,1.833 8.33333333,1.833 L5.66666667,1.833 C5.20642937,1.833 4.83333333,2.20609604 4.83333333,2.66633333 L4.83333333,3.5 L9.16666667,3.5 Z" />
              </svg>
            </Button>
            <Button className="filters__action">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="11"
                height="16"
                viewBox="0 0 11 16"
              >
                <path d="M6.74719403,0.673401503 L10.6443083,2.9234015 C10.8834547,3.06147269 10.9653922,3.36726789 10.827321,3.60641421 L5.7619768,12.3798478 C5.53030604,12.7811133 5.20472724,13.1201712 4.81318457,13.3679204 L1.60023459,15.4009194 C1.25657113,15.618373 0.80169595,15.5160597 0.584242679,15.1723967 C0.504497558,15.0463678 0.464900594,14.8990952 0.470691755,14.7500682 L0.618417197,10.9486067 C0.636473648,10.4839551 0.767410777,10.0306899 0.999911976,9.62798602 L6.06418133,0.856414205 C6.20225251,0.617267893 6.50804772,0.535330316 6.74719403,0.673401503 Z" />
                <path d="M5.68525791,3.51277967 L1.86596281,10.1279928 C1.71465251,10.39007 1.62943945,10.6850521 1.61768843,10.9874444 L1.48944098,14.2876729 L4.27850889,12.522886 C4.53332236,12.3616524 4.74520697,12.1409957 4.89597683,11.8798546 L8.71634683,5.26277967 L5.68525791,3.51277967 Z M6.74721946,0.673408318 L10.6443338,2.92340832 C10.8834801,3.06147951 10.9654177,3.36727471 10.8273465,3.60642102 L5.76200223,12.3798546 C5.53033147,12.7811201 5.20475267,13.120178 4.81321,13.3679272 L1.60026002,15.4009262 C1.25659656,15.6183799 0.801721383,15.5160665 0.584268113,15.1724035 C0.504522992,15.0463747 0.464926027,14.899102 0.470717188,14.750075 L0.61844263,10.9486136 C0.636499082,10.4839619 0.76743621,10.0306967 0.999937409,9.62799284 L6.06420676,0.85642102 C6.20227795,0.617274708 6.50807315,0.535337131 6.74721946,0.673408318 Z" />
              </svg>
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default Filter;
